import { render } from "./Products.vue?vue&type=template&id=8babd7b8&scoped=true&ts=true"
import script from "./Products.vue?vue&type=script&lang=ts"
export * from "./Products.vue?vue&type=script&lang=ts"

import "./Products.vue?vue&type=style&index=0&id=8babd7b8&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8babd7b8"]])

export default __exports__